export enum OrderVariant {
  IpNormal = 'Fiber',
  Normal = 'DTT',
  IpNormalBrl = 'IP Normal i BRL',
  Unknown = 'Unknown',
}
